import { useCallback, useEffect, useState } from "react";

const read = (key) => {
  if (!key) return [];
  try {
    const v = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(v) ? v.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
};

/** Últimos `max` ids usados en un selector, por usuario y por tipo de entidad (localStorage). */
export function useRecents(entityKey, userId, max = 5) {
  const storageKey = entityKey ? `dnf.recents.${entityKey}.${userId || "anon"}` : null;
  const [ids, setIds] = useState(() => read(storageKey));

  useEffect(() => { setIds(read(storageKey)); }, [storageKey]);

  const push = useCallback((id) => {
    if (!storageKey || !id) return;
    const next = [id, ...read(storageKey).filter((x) => x !== id)].slice(0, max);
    try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch { /* quota */ }
    setIds(next);
  }, [storageKey, max]);

  return [ids, push];
}
